export function buildTwitterSrcDoc(videoUrl: string): string {
    return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style>
          body { 
            margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; 
            min-height: 80vh; background: transparent; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; 
          }
          
          #loader { display: flex; flex-direction: column; align-items: center; gap: 12px; position: absolute; }
          .spinner { width: 28px; height: 28px; border: 3px solid #f3f3f3; border-top: 3px solid #000; border-radius: 50%; animation: spin 1s linear infinite; }
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          .loader-text { color: #536471; font-size: 14px; font-weight: 500; }
          
          #error-container { display: none; flex-direction: column; align-items: center; text-align: center; padding: 24px; max-width: 450px; width: 90%; }
          .x-logo { width: 32px; height: 32px; fill: #000; margin-bottom: 16px; }
          .msg { color: #536471; font-size: 14px; line-height: 1.6; margin-bottom: 20px; }
          .btn-view { padding: 10px 24px; border-radius: 99px; background: #000; color: #fff; font-size: 14px; font-weight: 600; text-decoration: none; transition: opacity 0.2s; }
          .btn-view:hover { opacity: 0.8; }

          #tweet-container { opacity: 0; transition: opacity 0.5s ease-in-out; width: 100%; display: flex; justify-content: center; }
        </style>
      </head>
      <body>
        
        <div id="loader">
          <div class="spinner"></div>
          <span class="loader-text">Đang tải nội dung từ X...</span>
        </div>

        <div id="error-container">
          <svg class="x-logo" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 22.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.008 5.965H5.078z"/></svg>
          <p class="msg">Trình duyệt của bạn đang chặn hiển thị trực tiếp từ X (Twitter) hoặc bài viết đã bị ẩn.</p>
          <a class="btn-view" href="${videoUrl}" target="_blank">Xem trên X.com</a>
        </div>

        <div id="tweet-container">
          <blockquote class="twitter-tweet" data-dnt="true" data-align="center">
            <a href="${videoUrl}"></a>
          </blockquote>
        </div>

        <script>
          let isLoaded = false;
          
          function showError() {
            if (isLoaded) return;
            document.getElementById('loader').style.display = 'none';
            document.getElementById('tweet-container').style.display = 'none';
            document.getElementById('error-container').style.display = 'flex';
          }

          const script = document.createElement('script');
          script.src = 'https://platform.twitter.com/widgets.js';
          script.async = true;
          script.charset = 'utf-8';
          
          script.onerror = showError; 
          document.body.appendChild(script);

          window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {};
            if (d.getElementById(id)) return t;
            t._e = [];
            t.ready = function(f) { t._e.push(f); };
            return t;
          }(document, "script", "twitter-wjs"));

          window.twttr.ready(function (twttr) {
            twttr.events.bind('rendered', function (event) {
              isLoaded = true;
              document.getElementById('loader').style.display = 'none';
              document.getElementById('tweet-container').style.opacity = '1'; 
            });
          });

          setTimeout(function() {
            if (!isLoaded) {
              showError();
            }
          }, 4000);
        </script>
      </body>
    </html>
  `;
}